import SignUpFormShort from 'components/auth/sign-up-short'
import { FC, useEffect } from 'react'
import { useQueryParams } from '~hooks'
import { Modal } from '~shared'

type ModalSignUpProps = {
  isOpen: boolean
  canFollow: boolean
  setIsOpen: (state: boolean) => void
  follow: () => void
  starName: string
  redirectUrl: string
}
const ModalSignUp: FC<ModalSignUpProps> = ({
  isOpen,
  setIsOpen,
  starName,
  canFollow,
  redirectUrl,
  follow,
}) => {
  const { replace, query } = useQueryParams()

  useEffect(() => {
    if (Boolean(query.follow) && canFollow) {
      follow()
      replace({ pathname: redirectUrl, query: { follow: null } })
    }
  }, [query.follow, canFollow])

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} closeButton>
      <SignUpFormShort
        onFinish={follow}
        message={`Create an account to follow "${starName}"`}
        logInQuery={{ redirect: redirectUrl, follow: true }}
      />
    </Modal>
  )
}

export default ModalSignUp
